import flBusiness from '@framelink/flbusiness'

export const errorExist = flBusiness.Enum.ErrorCode.AlreadyExist
export const errorAwaiting = flBusiness.Enum.ErrorCode.Awaiting
export const errorExpired = flBusiness.Enum.ErrorCode.Expired

export const emailInvalidRecipientUniq = flBusiness.Enum.ErrorCode.EmailInvalidRecipientUniq
export const emailInvalidRecipientGdpr = flBusiness.Enum.ErrorCode.EmailInvalidRecipientGdpr
export const emailInvalidRecipientAdrs = flBusiness.Enum.ErrorCode.EmailInvalidRecipientAdrs
export const emailInvalidRecipientEmpt = flBusiness.Enum.ErrorCode.EmailInvalidRecipientEmpt
export const emailPersonalDataOversize = flBusiness.Enum.ErrorCode.EmailPersonalDataOversize

export const dataExportSourceType = flBusiness.Enum.DataExportSourceType

export const feedbackStatus = flBusiness.Enum.FeedbackStatus

export const linkedFieldNoFilterValue = flBusiness.Enum.LinkedInactiveType.NoFilterValue
export const linkedFieldUsedByOther = flBusiness.Enum.LinkedInactiveType.UsedByOther

export const cards = flBusiness.Enum.CardType

export const messageLinkTrue = flBusiness.Enum.ServiceUtil.LinkTrue
export const messageLinkFalse = flBusiness.Enum.ServiceUtil.LinkFalse
